import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ItemStatus} from 'models/board';
import {AppRootState} from 'store/appStore';

interface ItemStatusState {
    statuses: ItemStatus[];
    selectedStatus: ItemStatus | null;
    reloadTheStatusItemsById?: string;
    statusItemsCount: {[key: string]: number};
}

const initialState: ItemStatusState = {
    statuses: [],
    selectedStatus: null,
    statusItemsCount: {},
};

const itemStatusSlice = createSlice({
    name: 'itemStatus',
    initialState,
    reducers: {
        setItemStatuses: (state, action: PayloadAction<ItemStatus[]>) => {
            state.statuses = action.payload;
        },
        addStatus: (state, action: PayloadAction<ItemStatus>) => {
            state.statuses.push(action.payload);
        },
        setSelectedStatus: (state, action: PayloadAction<ItemStatus | null>) => {
            state.selectedStatus = action.payload;
        },

        removeStatus: (state, action: PayloadAction<string>) => {
            state.statuses = state.statuses.filter(status => status.id !== action.payload);
        },
        removeStatuses: (state, action: PayloadAction<string[]>) => {
            state.statuses = state.statuses.filter(status => !action.payload.includes(status.id));
        },
        setReloadTheStatusItemsById: (state, action: PayloadAction<string | undefined>) => {
            state.reloadTheStatusItemsById = action.payload;
        },
        setStatusItemsCount: (state, action: PayloadAction<{[key: string]: number} | undefined>) => {
            state.statusItemsCount = action.payload ?? {};
        },
    },
});

export const {
    removeStatus,
    addStatus,
    setItemStatuses,
    setSelectedStatus,
    removeStatuses,
    setReloadTheStatusItemsById,
    setStatusItemsCount,
} = itemStatusSlice.actions;

export const itemStatusSliceReducer = itemStatusSlice.reducer;
export const itemStatusSelector = (rootState: AppRootState): ItemStatusState => rootState.itemStatues;
